/**
 * The risk scale shared by the Risks tab and presentation slides (MYD-502):
 * the axis labels, the severity bands of likelihood × impact, and their
 * colours. One definition, so a slide cannot call a risk "High" that the tab
 * calls "Medium". The backend mirrors the bands in
 * presentations/providers/evaluationElements.js (severityOf).
 */

export const LIKELIHOOD_LABELS = ['', 'Rare', 'Unlikely', 'Possible', 'Likely', 'Almost certain']
export const IMPACT_LABELS = ['', 'Negligible', 'Minor', 'Moderate', 'Major', 'Catastrophic']

export type Severity = 'low' | 'medium' | 'high'

export function severityFromScore(score: number): Severity {
	if (score <= 4) return 'low'
	if (score <= 15) return 'medium'
	return 'high'
}

export const SEVERITY_CLASSES: Record<Severity, { cell: string; label: string; chip: string }> = {
	low: {
		cell: 'bg-emerald-100 hover:bg-emerald-200 text-emerald-800 border-emerald-200',
		label: 'Low',
		chip: 'bg-emerald-100 text-emerald-700',
	},
	medium: {
		cell: 'bg-amber-100 hover:bg-amber-200 text-amber-800 border-amber-200',
		label: 'Medium',
		chip: 'bg-amber-100 text-amber-700',
	},
	high: {
		cell: 'bg-red-100 hover:bg-red-200 text-red-800 border-red-200',
		label: 'High',
		chip: 'bg-red-100 text-red-700',
	},
}
